// Importacion de Bootstrap
import 'bootstrap/dist/js/bootstrap';
import 'bootswatch/dist/cosmo/bootstrap.css';
import 'bootstrap-icons/font/bootstrap-icons.min.css';

// Importaciones de estilos generales
import './css/main.css';
import './css/loader.css';
import './css/kpis.css';
import './css/home.css';
import './css/settings.css';

// Definicion de rutas generales
const currentPath = window.location.pathname;
const ALL_ROUTES: Routes = {
  '^/dasboard$': () => import('./pages/dashboard'),
  '^/login$': () => import('./pages/login'),
  '^/users$': () => import('./pages/users'),
  '^/users/check$': () => import('./pages/usersCheck'),
  '^/users/check/\\d+$': () => import('./pages/userCkeck'),
  '^/kpis$': () => import('./pages/kpis'),
  '^/settings': () => import('./pages/settings'),
  '^/whmcs-jobs$': () => import('./pages/whmcsJobs'),
  '^/public-api$': () => import('./pages/publicApi'),
  '^/public-api/(keys|users)/\\d+$': () => import('./pages/publicApiDetail')
};

/**
 * Ejecución de la carga de modulos de la plataforma
 */
(async() => {
  try {
    const matchedRoute = Object.keys(ALL_ROUTES)
      .find((pattern) =>
        new RegExp(pattern).test(currentPath)
      );
    if (!matchedRoute) return;

    const [module, header, app] = await Promise.all([
      ALL_ROUTES[matchedRoute](),
      import('./partials/header'),
      import('./partials/app')
    ]);

    app.main();
    header.main();
    module.main();

    if (process.env.NODE_ENV === 'dev') (await import('./develop')).default();
  } catch (error) {
    /** TODO: MAnejo de errores con la plataforma. */
    console.error('Error al cargar los módulos:', error);
  }
})();

// Definicion de Tipos e Interfaces
type Routes = {
  [key: string]: () => Promise<{ main: () => void }>;
};
